import * as i0 from '@angular/core';
import { Component, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { AutoSizeInputModule } from '@beego/ngx-autosize-input';

class DataFilterComponent {
    name;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: DataFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.7", type: DataFilterComponent, selector: "filter-component", inputs: { name: "name" }, ngImport: i0, template: "<div class=\"_filter-component\">\n    <p class=\"_filter-name\">{{ name }}</p>\n    <span class=\"_selected\">\n        <ng-content select=\"[filter-content]\"></ng-content>\n    </span>\n</div>", styles: ["._filter-component{background-color:#fff;border:1px solid #D3D3D3;border-radius:12px;margin-right:20px;width:-moz-fit-content;width:fit-content;height:100%;display:flex;flex-direction:row;align-items:center;padding:0 15px;position:relative}._filter-component ._filter-name{color:gray;margin:5px 0;text-transform:uppercase}._filter-component ._selected{font-weight:450}\n"] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: DataFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'filter-component', template: "<div class=\"_filter-component\">\n    <p class=\"_filter-name\">{{ name }}</p>\n    <span class=\"_selected\">\n        <ng-content select=\"[filter-content]\"></ng-content>\n    </span>\n</div>", styles: ["._filter-component{background-color:#fff;border:1px solid #D3D3D3;border-radius:12px;margin-right:20px;width:-moz-fit-content;width:fit-content;height:100%;display:flex;flex-direction:row;align-items:center;padding:0 15px;position:relative}._filter-component ._filter-name{color:gray;margin:5px 0;text-transform:uppercase}._filter-component ._selected{font-weight:450}\n"] }]
        }], propDecorators: { name: [{
                type: Input
            }] } });

class FilterModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: FilterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.7", ngImport: i0, type: FilterModule, declarations: [DataFilterComponent], imports: [CommonModule, FormsModule, IonicModule, AutoSizeInputModule], exports: [DataFilterComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: FilterModule, imports: [CommonModule, FormsModule, IonicModule, AutoSizeInputModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: FilterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DataFilterComponent],
                    exports: [DataFilterComponent],
                    imports: [CommonModule, FormsModule, IonicModule, AutoSizeInputModule],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/*
 * Public API Surface of ngx-filter
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DataFilterComponent, FilterModule };
